<template>
	<button class="button-mobile-menu" @click.prevent="$root.$emit('showMobileMenu')">
		<i class="fa fa-bars"></i>
	</button>
</template>

<script>
export default {};
</script>

<style lang="stylus"></style>
